import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import Lightbox from '@seafile/react-image-lightbox';
import './viewer-image.css';
var ViewerImage = /*#__PURE__*/function (_React$Component) {
  _inherits(ViewerImage, _React$Component);
  var _super = _createSuper(ViewerImage);
  function ViewerImage(props) {
    var _this;
    _classCallCheck(this, ViewerImage);
    _this = _super.call(this, props);
    _this.toggleBigImage = function (event) {
      event && event.preventDefault();
      _this.setState({
        isShowBigImage: !_this.state.isShowBigImage
      });
    };
    _this.renderBigImage = function (src) {
      return /*#__PURE__*/React.createElement(Lightbox, {
        wrapperClassName: "sf-editor-image-previewer",
        mainSrc: src,
        imagePadding: 70,
        onCloseRequest: _this.toggleBigImage,
        reactModalStyle: {
          overlay: {
            zIndex: 1071
          }
        }
      });
    };
    _this.state = {
      isShowBigImage: false
    };
    return _this;
  }
  _createClass(ViewerImage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        attributes = _this$props.attributes,
        node = _this$props.node;
      var data = node.data;
      var isShowBigImage = this.state.isShowBigImage;
      var src = data.src;
      if (!src) {
        return /*#__PURE__*/React.createElement("span", attributes, "Loading...");
      }
      return /*#__PURE__*/React.createElement("span", {
        className: "seafile-ed-image seafile-ed-image-viwer"
      }, /*#__PURE__*/React.createElement("img", Object.assign({
        draggable: false,
        src: src,
        alt: ""
      }, attributes, {
        width: data.width,
        height: data.height
      })), /*#__PURE__*/React.createElement("span", {
        onClick: this.toggleBigImage,
        className: "image-full-button"
      }, /*#__PURE__*/React.createElement("i", {
        className: 'iconfont icon-fullscreen'
      })), isShowBigImage && this.renderBigImage(src));
    }
  }]);
  return ViewerImage;
}(React.Component);
export default ViewerImage;